import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { dashboardRoute } from "@dealer-center/ddc-pages-dashboard-react";
import { DealerIndex } from "./helpers/DealerIndex";
import { PagesAbout } from "@dealer-center/ddc-pages-about";
import { PagesAccountCopyUi } from "@dealer-center/ddc-pages-media-library-copy-react";
import { PagesResourceAutoLogUi } from "@dealer-center/ddc-pages-resource-auto-log-react";
import { AccountFranchiseAuditLogPage } from "@dealer-center/ddc-pages-account-franchise-audit-log-react";
import type { environments } from "@dealer-center/core-enviroment";

export const dealerRoutes = (enviroment: environments): RouteObject => ({
  path: "dealer/:dealer/*",
  element: <DealerIndex />,
  children: [
    {
      index: true,
      element: <Navigate to="dashboard" />
    },
    dashboardRoute(enviroment),
    {
      path: "about",
      element: <PagesAbout />
    },
    {
      path: "media-library-copy",
      element: <PagesAccountCopyUi />
    },
    {
      path: "example",
      element: <div>This is an example page for a dealer</div>
    },
    { path: "resourceAutoLog", element: <PagesResourceAutoLogUi /> },
    {
      path: "accountFranchiseAuditLog",
      element: <AccountFranchiseAuditLogPage />
    },
    {
      path: "*",
      element: <Navigate to="dashboard" />
    }
  ]
});
